import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

type Direction = 'prev' | 'next';

interface CarouselNavButtonProps {
  direction: Direction;
  onClick: () => void;
}

export function CarouselNavButton({ direction, onClick }: CarouselNavButtonProps) {
  const isPrev = direction === 'prev';
  const Icon = isPrev ? ChevronLeft : ChevronRight;
  const positionClass = isPrev ? '-left-1 sm:-left-12' : '-right-1 sm:-right-12';
  const ariaLabel = isPrev ? 'Предыдущий слайд' : 'Следующий слайд';

  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        'absolute top-1/2 -translate-y-1/2 z-20',
        positionClass,
        'w-20 h-20 flex items-center justify-center',
        'backdrop-blur-md bg-white/10 hover:bg-white/20',
        'transition-colors transition-opacity opacity-0 group-hover:opacity-100',
        'shadow-[0px_19px_24px_rgba(0,0,0,0.19)]',
        'rounded-[28px]',
      )}
    >
      <Icon className="h-full w-full text-white" />
    </button>
  );
}
